const unpaidNotice = document.getElementById('js-close-unpaid-notice')
if (unpaidNotice && window.localStorage.getItem('unpaid') !== 'hidden') {
  unpaidNotice.parentElement.classList.remove('hide')

  unpaidNotice.addEventListener('click', () => {
    unpaidNotice.parentElement.classList.add('hide')
    window.localStorage.setItem('unpaid', 'hidden')
  })
}
